/** Routing regions for Scribe API host resolution (owned by @heidi/api/config). */
export enum Region {
  UK = 'UK',
  CA = 'CA',
  US = 'US',
  AU = 'AU',
  EU = 'EU',
  CH = 'CH',
  JP_AZ1 = 'JP-AZ1',
  AU_AZ1 = 'AU-AZ1',
  UAE_AZ1 = 'UAE-AZ1',
  US_AZ1 = 'US-AZ1',
  QAT_AZ1 = 'QAT-AZ1',
  SE_AZ1 = 'SE-AZ1',
}
